import { render, staticRenderFns } from "./TheAvatarLetter.vue?vue&type=template&id=694d9ffd&scoped=true&"
import script from "./TheAvatarLetter.vue?vue&type=script&lang=js&"
export * from "./TheAvatarLetter.vue?vue&type=script&lang=js&"
import style0 from "./TheAvatarLetter.vue?vue&type=style&index=0&id=694d9ffd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694d9ffd",
  null
  
)

export default component.exports